import { render, staticRenderFns } from "./pocket.vue?vue&type=template&id=51a2bc11&scoped=true&"
import script from "./pocket.vue?vue&type=script&lang=js&"
export * from "./pocket.vue?vue&type=script&lang=js&"
import style0 from "./pocket.vue?vue&type=style&index=0&id=51a2bc11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a2bc11",
  null
  
)

export default component.exports